<template>
  <b-card>
    <vue-apex-charts
      type="donut"
      height="350"
      ref="donutChart"
      :options="localOption"
      :series="localSeries"
    />
  </b-card>
</template>

<script>
import {
  BCard, BCardTitle, BCardSubTitle,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import apexChatData from './apexChartData'

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardTitle,
    BCardSubTitle,
  },
  props: {
    chartData: {
      type: Object,
      default: () => ({}), // Varsayılan boş obje
    },
  },
  data() {
    return {
      apexChatData,
      localOption:apexChatData.donutChart.chartOptions,
      localSeries:[]
    }
  },
  mounted () {
  },
  methods: {
    updateChart() {
      this.localOption.labels = [...this.localData.labels]
      this.localSeries = [...this.localData.series]
      this.localOption.plotOptions.pie.donut.labels.total.label="Toplam"
      this.localOption.plotOptions.pie.donut.labels.total.formatter= () => this.localData.detail.orders.length + ' Adet'
      
      this.localOption.plotOptions.pie.donut.labels.value.formatter = (val, opts) => {
        const seriesIndex = opts.globals.series.indexOf(parseFloat(val));
        
        if (seriesIndex !== -1 && this.localData.counts[seriesIndex]) {
          return `${this.localData.counts[seriesIndex]} Adet`;
        }

        return `${parseInt(val)} Adet`;
      };
    },
  },
  watch: {
    chartData: {
      handler(newData) {
        this.localData = newData;
        this.updateChart();
      },
      deep: true,
      immediate: true, // İlk yüklemede çalıştır
    },
  },
}
</script>
